import ToggleColorMode from "./ToggleColorMode";
import Views from "./Views";

function App() {
  return (
    <div className="App">
      <ToggleColorMode />
      <Views />
    </div>
  );
}

export default App;
